module.exports = __webpack_public_path__ + "img/Rijkswaterstaat.ef136223.svg";